<template>
	<div class="layer-project" data-project-name="kb-card">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<section class="project-visual">
				<div>
					<h1 class="project-tit">
						KB <br />Corporate Card <span class="nowrap block">Mobile App</span>
					</h1>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<div class="project-overview-tit"><strong>Overview</strong></div>
					<p class="project-overview-desc">
						KB국민카드의 기업 회원을 대상으로 신규 APP을 구축하였습니다.<br />카드신청,
						사용내역 확인, 한도관리, 법인카드 현황/사용 내역 조회 등의 편의 기능
						제공을 목적으로 제작된 서비스입니다.
					</p>
					<div class="diagram-wrap">
						<ul class="diagram diagram01">
							<li class="item">Design <br />Trend</li>
							<li class="item">Imporved <br />UI/UX Design</li>
							<li class="item">User <br />Convenience</li>
						</ul>
						<ul class="diagram diagram02">
							<li class="item">
								KB <br class="break-m break-t" />Corporate
								<br class="break-w" />Card <br class="break-m break-t" />Mobile
								App
							</li>
						</ul>
					</div>
				</div>
			</section>
			<section class="section app-main">
				<div class="inner-section">
					<strong class="project-subtit">APP</strong>
					<p class="project-desc">
						대금 즉시 결제 등의 주요 프로세스 간소화 및
						<br class="break-t" />최신 프로세스 디자인 트렌드를
						<br class="break-w" />반영하고 <br class="break-t" />직관적인
						UI(User Interface)를 제공합니다.
					</p>
					<div class="img-wrap">
						<div class="main">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/kb-card/kb-card-app-main-img-02@m.png"
							/>
						</div>
						<div class="app">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/kb-card/kb-card-app-main-img-01@m.png"
							/>
						</div>
					</div>
				</div>
			</section>
			<section class="section app-contents">
				<div class="inner-section">
					<div class="swiper-container">
						<ul class="swiper-wrapper">
							<li class="swiper-slide">
								<div>
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/kb-card/kb-card-app-contents-img-01.png"
									/>
									<p class="text">이용안내</p>
								</div>
							</li>
							<li class="swiper-slide">
								<div>
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/kb-card/kb-card-app-contents-img-02.png"
									/>
									<p class="text">카드신청</p>
								</div>
							</li>
							<li class="swiper-slide">
								<div>
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/kb-card/kb-card-app-contents-img-03.png"
									/>
									<p class="text">로그인</p>
								</div>
							</li>
							<li class="swiper-slide">
								<div>
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/kb-card/kb-card-app-contents-img-04.png"
									/>
									<p class="text">회원정보 변경</p>
								</div>
							</li>
							<li class="swiper-slide">
								<div>
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/kb-card/kb-card-app-contents-img-05.png"
									/>
									<p class="text">공인인증서 관리</p>
								</div>
							</li>
						</ul>
						<div class="swiper-pagination"></div>
					</div>
					<div class="sub">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/kb-card/kb-card-app-contents-img-02-02@m.png"
						/>
					</div>
				</div>
			</section>
			<section class="section app-contents-02">
				<div class="inner-section">
					<div class="my-kb">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/kb-card/kb-card-app-contents-02-img-01@m.png"
						/>
					</div>
				</div>
			</section>
			<section class="section app-contents-03">
				<div class="inner-section">
					<div class="app">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/kb-card/kb-card-app-contents-03-img-01@m.png"
						/>
					</div>
					<div class="text-wrap">
						<p class="kb-kookmin">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/kb-card/kb-card-app-contents-03-img-02@m.png"
							/>
						</p>
						<p class="biz-card">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/kb-card/kb-card-app-contents-03-img-03@m.png"
							/>
						</p>
					</div>
				</div>
			</section>
			<section class="section style">
				<div class="inner-section">
					<div class="point-color-wrap">
						<strong class="project-subtit">Colors</strong>
						<div class="color-section primary-colors">
							<strong class="color-tit">Primary Colors</strong>
							<ul class="point-color">
								<li class="item">
									<div class="color"></div>
									<div class="tit">
										<strong>KB BizCard <br class="break-t" />Blue</strong>
									</div>
									<div class="code">#6398ee</div>
								</li>
								<li class="item">
									<div class="color"></div>
									<div class="tit">
										<strong>KB BizCard <br class="break-t" />Purple</strong>
									</div>
									<div class="code">#798ef1</div>
								</li>
								<li class="item">
									<div class="color"></div>
									<div class="tit">
										<strong>KB BizCard <br class="break-t" />BlueGreen</strong>
									</div>
									<div class="code">#45aed3</div>
								</li>
							</ul>
						</div>
						<div class="color-section secondary-colors">
							<strong class="color-tit">Secondary Colors</strong>
							<ul class="point-color">
								<li class="item">
									<div class="color"></div>
									<div class="tit">
										<strong>KB BizCard <br class="break-t" />Deep Blue</strong>
									</div>
									<div class="code">#3063cc</div>
								</li>
								<li class="item">
									<div class="color"></div>
									<div class="tit">
										<strong
											>KB BizCard <br class="break-t" />Signiture Yellow</strong
										>
									</div>
									<div class="code">#ffcc00</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="point-font-wrap">
						<strong class="project-subtit">Fonts</strong>
						<div class="font-section">
							<strong class="font-tit">Apple SD Gothic Neo</strong>
							<ul>
								<li class="item">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/kb-card/style-font-apple-sd-gothic-neo-regular@mt.png"
										data-break="mt-w"
									/>
								</li>
								<li class="item">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/kb-card/style-font-apple-sd-gothic-neo-bold@mt.png"
										data-break="mt-w"
									/>
								</li>
							</ul>
						</div>
						<div class="font-section">
							<strong class="font-tit">Roboto</strong>
							<ul>
								<li class="item">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/kb-card/style-font-roboto-regular@mt.png"
										data-break="mt-w"
									/>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</section>
			<!-- Details [e] -->
			<!-- Project Client [s] -->
			<section class="project-client">
				<strong class="a11y-hidden">LG Chem ESS Battery Division</strong>
			</section>
			<!-- Project Client [e] -->
			<!-- <section>
            <img src="" alt="" data-src="/static/img/project-detail/kb-card/kb-card-img-01@m.jpg" >
        </section>
        <section>
            <img src="" alt="" data-src="/static/img/project-detail/kb-card/kb-card-img-02-01@m.jpg" >
            <img src="" alt="" data-src="/static/img/project-detail/kb-card/kb-card-img-02-02@m.jpg" >
            <img src="" alt="" data-src="/static/img/project-detail/kb-card/kb-card-img-02-03@m.jpg" >
            <img src="" alt="" data-src="/static/img/project-detail/kb-card/kb-card-img-02-04@m.jpg" >
        </section>
        <section>
            <img src="" alt="" data-src="/static/img/project-detail/kb-card/kb-card-img-03-01@m.jpg" >
            <img src="" alt="" data-src="/static/img/project-detail/kb-card/kb-card-img-03-02@m.jpg" >
        </section>
        <section>
            <img src="" alt="" data-src="/static/img/project-detail/kb-card/kb-card-img-04@m.jpg" >
        </section> -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var isAppContentsSwiper = false;
		var appContentsSwiper;
		appContentsSwiperSet();

		$(window).on("resize", function () {
			var w = $(window).outerWidth();
			if (w >= 712 && isAppContentsSwiper) {
				appContentsSwiper.destroy();
				isAppContentsSwiper = false;
			}

			if (w < 712) {
				appContentsSwiperSet();
			}
		});

		function appContentsSwiperSet() {
			var w = $(window).outerWidth();

			if (isAppContentsSwiper | (w >= 712)) {
				return;
			}

			isAppContentsSwiper = true;
			appContentsSwiper = new Swiper(".app-contents .swiper-container", {
				slidesPerView: "auto",
				spaceBetween: 20,
				centeredSlides: true,
				pagination: {
					el: ".app-contents .swiper-pagination",
					clickable: true,
				},
			});
		}
	},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/swiper.min.css"; /* if use swiper.min.js */
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* temp */
.project-tit .nowrap {
	display: inline-block;
}
.project-tit .block {
	display: block;
}
.project-client {
	background: #f6f8fc url(/static/img/project-detail/kb-card/ci.png) 50% / auto
		36.5px no-repeat;
}

@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/kb-card/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/kb-card/bg-overview@t.jpg);
	}
	.project-tit br {
		display: none;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/kb-card/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 73px;
	}
}

/* project-overview [s] */
.project-overview {
	background-color: #7a92ee;
}
.project-overview .project-overview-tit,
.project-overview .project-overview-desc {
	color: #fff;
}
.project-overview .diagram-wrap {
	margin-top: 24px;
}
.project-overview .diagram {
	display: flex;
	justify-content: center;
	justify-content: center;
	flex-wrap: wrap;
	position: relative;
	margin: 0 auto;
}
.project-overview .diagram .item {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 138px;
	height: 138px;
	color: #646973;
	border: 1px solid #fff;
	border-radius: 50%;
	text-align: center;
	color: #fff;
}
.project-overview .diagram01::after {
	content: "";
	position: absolute;
	bottom: -21px;
	left: 50%;
	width: 1px;
	height: 42px;
	background-color: #fff;
}
.project-overview .diagram02 .item {
	border: none;
	background-color: #ffcc00;
}
@media screen and (max-width: 711px) {
	.project-overview .diagram {
		width: 269px;
	}
	.project-overview .diagram + .diagram {
		margin-top: 30px;
	}
	.project-overview .diagram .item:nth-child(2) {
		margin-left: -8px;
	}
	.project-overview .diagram .item:nth-child(3) {
		margin-top: -24px;
	}
}
@media screen and (min-width: 712px) {
	.project-overview .diagram-wrap {
		display: flex;
		justify-content: space-between;
		width: 632px;
		margin-right: auto;
		margin-left: auto;
	}
	.project-overview .diagram01 {
		margin: 0;
	}
	.project-overview .diagram01::after {
		top: 50%;
		right: -103px;
		left: auto;
		width: 87px;
		height: 1px;
	}
	.project-overview .diagram02 {
		margin: 0;
	}
	.project-overview .diagram .item {
		width: 132px;
		height: 132px;
		padding: 0 10px;
	}
	.project-overview .diagram .item + .item {
		margin-left: -8px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview {
		padding-top: 45px;
		padding-bottom: 60px;
	}
	.project-overview .diagram-wrap {
		width: 1179px;
		margin-top: 48px;
	}
	.project-overview .diagram .item {
		width: 246px;
		height: 246px;
		padding: 0 30px;
		border-width: 2px;
		font-size: 2rem;
	}
	.project-overview .diagram .item + .item {
		margin-left: -14px;
	}
	.project-overview .diagram01::after {
		right: -192px;
		width: 162px;
		height: 2px;
	}
}
/* project-overview [e] */

/* app-main [s] */
.app-main {
	background-color: #f6f8fc;
}
.app-main .project-desc {
	color: #666;
}
.app-main .img-wrap {
	position: relative;
}
.app-main .app {
	position: relative;
	z-index: 1;
	margin: 0 -15px;
}
.app-main .app img {
	width: 100%;
}
.app-main .main {
	position: absolute;
	top: 25.625%;
	right: 0;
	left: -15px;
}
.app-main .main img {
	width: 58.4375%;
}

@media screen and (min-width: 712px) {
	.app-main .project-subtit {
		margin-top: 70px;
	}
	.app-main .img-wrap {
		margin-top: -19%;
	}
	.app-main .app {
		right: 0;
		left: 0;
		margin: 0 -40px;
		text-align: right;
	}
	.app-main .app img {
		width: 69.1011%;
	}
	.app-main .main {
		top: 45.625%;
		left: -40px;
	}
	.app-main .main img {
		width: 43.5028%;
	}
}

@media screen and (min-width: 1280px) {
	.app-main {
		overflow: hidden;
		position: relative;
		height: 1303px;
		padding-bottom: 0;
	}
	.app-main .project-subtit {
		margin-top: 120px;
		margin-bottom: 35px;
		font-size: 80px;
		line-height: 1;
	}
	.app-main .main {
		top: 510px;
		right: auto;
		left: 50%;
		margin-left: -960px;
	}
	.app-main .main img {
		width: auto;
		max-width: inherit;
	}
	.app-main .img-wrap {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin-top: 2.76%;
	}
	.app-main .app {
		position: absolute;
		top: 0;
		left: 50%;
		margin: 0 0 0 -328px;
	}
	.app-main .app img {
		width: auto;
		max-width: inherit;
	}
	/* .app-main .main{left:-60px;}
        .app-main .app{margin:0 -60px;} */
}
/* app-main [e] */

/* app-contents [s] */
.app-contents {
	padding-right: 0;
	padding-left: 0;
	background-color: #f6f8fc;
}
.app-contents .swiper-container {
	overflow: visible;
	padding-bottom: 32px;
}
.app-contents .swiper-slide {
	width: 43.59%;
	text-align: center;
}
.app-contents .swiper-slide img {
	background-color: #fff;
	box-shadow: 63px 57px 98px 0px rgba(31, 33, 34, 0.15);
	border-radius: 20px;
}
.app-contents .text {
	margin-top: 14px;
	font-size: 1.3rem;
	color: #777;
	line-height: 1.1;
	text-align: center;
}
.app-contents .sub {
	display: none;
}

@media screen and (min-width: 712px) {
	.app-contents .swiper-container {
		z-index: 2;
		width: 39.6769%;
		margin: 0 0 0 40px;
		padding-bottom: 0;
	}
	.app-contents .swiper-wrapper {
		flex-wrap: wrap;
	}
	.app-contents .swiper-slide {
		flex: none;
		width: 44.4247%;
		height: auto;
	}
	.app-contents .swiper-slide + .swiper-slide {
		margin-top: 6%;
	}
	.app-contents .swiper-slide:nth-child(odd) {
		margin-right: 11.1504%;
	}
	.app-contents .swiper-slide:nth-child(even) {
		margin-top: 0;
	}
	.app-contents .swiper-slide:nth-child(2) > div {
		transform: translateY(42%);
	}
	.app-contents .swiper-slide:nth-child(4) > div {
		transform: translateY(48%);
	}
	.app-contents .swiper-pagination {
		display: none;
	}
	.app-contents .sub {
		display: block;
		position: relative;
		z-index: 1;
		margin-top: -17%;
		margin-left: 20%;
	}
	.app-contents .sub img {
		width: 31.25%;
	}
}

@media screen and (min-width: 1280px) {
	.app-contents {
		position: relative;
		padding-top: 0;
		padding-bottom: 0;
	}
	.app-contents .swiper-container {
		width: 629px;
		margin-left: 0;
	}
	.app-contents .swiper-slide {
		width: 279px;
	}
	.app-contents .swiper-slide img {
		border-radius: 30px;
	}
	.app-contents .swiper-slide:nth-child(odd) {
		margin-right: 70px;
	}
	.app-contents .sub {
		position: absolute;
		bottom: 94px;
		left: 50%;
		margin-top: 0;
		margin-left: -360px;
	}
	.app-contents .sub img {
		width: 100%;
		max-width: inherit;
	}
}
/* app-contents [e] */

/* app-contents-02 [s] */
.app-contents-02 {
	padding-right: 0;
	padding-left: 0;
	background-color: #f6f8fc;
}
.app-contents-02 .my-kb img {
	width: 100%;
}

@media screen and (min-width: 712px) {
	.app-contents-02 {
		margin-top: -85% !important;
		padding-bottom: 92%;
	}
	.app-contents-02 .inner-section {
		text-align: right;
	}
	.app-contents-02 .my-kb {
		float: right;
		width: 47.3314%;
	}
}

@media screen and (min-width: 1280px) {
	.app-contents-02 {
		position: relative;
		margin-top: 0 !important;
		padding-bottom: 0;
	}
	.app-contents-02 .inner-section {
		padding-right: 0;
		padding-left: 0;
	}
	.app-contents-02 .my-kb {
		position: absolute;
		top: -1420px;
		left: 50%;
		width: auto;
		margin-left: 76px;
	}
	.app-contents-02 .my-kb img {
		width: auto;
		max-width: inherit;
	}
}
/* app-contents-02 [e] */

/* app-contents-03 [s] */
.app-contents-03 {
	overflow: hidden;
	position: relative;
	padding-right: 0;
	padding-bottom: 0;
	padding-left: 0;
	background-color: #f6f8fc;
}
.app-contents-03::before {
	content: "";
	position: absolute;
	bottom: -10%;
	left: -20%;
	width: 200%;
	padding-top: 109%;
	background-color: #7a8ef1;
	transform: rotate(-30deg);
}
.app-contents-03 .app {
	position: relative;
	z-index: 1;
}
.app-contents-03 .app img {
	width: 100%;
}
.app-contents-03 .kb-kookmin,
.app-contents-03 .biz-card {
	position: relative;
	z-index: 1;
	padding-left: 22.1875%;
}
.app-contents-03 .kb-kookmin {
	margin-top: -10.625%;
}
.app-contents-03 .biz-card {
	margin-top: 5.625%;
	margin-bottom: -2.8%;
}

@media screen and (min-width: 712px) {
	.app-contents-03 {
		overflow: visible;
		padding-top: 20%;
	}
	.app-contents-03::before {
		content: none;
	}
	.app-contents-03 .inner-section {
		overflow: hidden;
		margin-top: -40%;
	}
	.app-contents-03 .inner-section::before {
		content: "";
		position: absolute;
		bottom: -10%;
		left: -20%;
		width: 200%;
		padding-top: 88.6%;
		background-color: #7a8ef1;
		transform: rotate(-30deg);
	}
	.app-contents-03 .kb-kookmin,
	.app-contents-03 .biz-card {
		padding-left: 42.205%;
	}
	.app-contents-03 .kb-kookmin {
		margin-top: -19.625%;
	}
	.app-contents-03 .kb-kookmin img {
		width: 39.5631%;
	}
	.app-contents-03 .biz-card img {
		width: 90.2794%;
	}
}
@media screen and (min-width: 1280px) {
	.app-contents-03 {
		overflow: hidden;
		height: 1673px;
		margin-top: -255px !important;
		padding-top: 87.65%;
		padding-top: 0;
	}
	.app-contents-03 .inner-section {
		margin: 0;
		padding: 0;
	}
	.app-contents-03 .inner-section::before {
		bottom: -150px;
		padding-top: 0;
		padding-bottom: 1322px;
	}
	.app-contents-03 .app {
		position: absolute;
		top: 0;
		left: 50%;
		margin-left: -960px;
	}
	.app-contents-03 .app img {
		width: auto;
		max-width: inherit;
	}
	.app-contents-03 .text-wrap {
		position: absolute;
		bottom: -1.8%;
		left: 50%;
		margin-left: -48px;
	}
	.app-contents-03 .kb-kookmin {
		position: static;
		bottom: 0;
		left: auto;
		margin-top: 0;
		padding-left: 0;
	}
	.app-contents-03 .biz-card {
		position: static;
		bottom: 0;
		left: auto;
		margin-top: 6.54%;
		margin-bottom: 0;
		padding-left: 0;
	}
	.app-contents-03 .kb-kookmin img {
		width: 37.3%;
		max-width: inherit;
	}
	.app-contents-03 .biz-card img {
		width: 83.73%;
		max-width: inherit;
	}
}
/* app-contents-03 [e] */

/* style [s] */
.style {
	position: relative;
	z-index: 1;
	padding-bottom: 60px;
	background: #fff;
}
.style .color-tit,
.style .point-tit {
	display: block;
	margin-bottom: 25px;
	font-size: 1.5rem;
}
.style .point-color-wrap .item {
	position: relative;
	height: 60px;
	padding-top: 4px;
	padding-left: 90px;
}
.style .point-color-wrap .color {
	position: absolute;
	top: 0;
	left: 0;
	width: 60px;
	height: 60px;
	border-radius: 50%;
}
.style .point-color-wrap .tit {
	font-size: 1.3rem;
	line-height: 1.2;
}
.style .point-color-wrap .code {
	margin-top: 6px;
	font-size: 1.2rem;
}
.style .point-color-wrap .primary-colors .item:nth-child(1) .color {
	background-color: #6398ee;
}
.style .point-color-wrap .primary-colors .item:nth-child(2) .color {
	background-color: #798ef1;
}
.style .point-color-wrap .primary-colors .item:nth-child(3) .color {
	background-color: #45aed3;
}
.style .point-color-wrap .secondary-colors .item:nth-child(1) .color {
	background-color: #3063cc;
}
.style .point-color-wrap .secondary-colors .item:nth-child(2) .color {
	background-color: #ffcc00;
}
.style .point-color-wrap .color-section + .color-section {
	margin-top: 36px;
}
.style .point-font-wrap {
	margin-top: 41px;
}
.style .point-font-wrap .font-tit {
	display: block;
	margin-bottom: 18px;
}
.style .point-font-wrap .font-section > ul {
	display: flex;
}
.style .point-font-wrap .font-section .item img {
	width: 130px;
	box-shadow: 25px 23px 40px 0px rgba(0, 0, 0, 0.15);
	border-radius: 15px;
}
.style .point-font-wrap .font-section .item + .item {
	margin-left: 30px;
}

@media screen and (max-width: 711px) {
	.style .point-color-wrap .item + .item {
		margin-top: 20px;
	}
	.style .point-font-wrap .font-section + .font-section {
		margin-top: 36px;
	}
}
@media screen and (min-width: 712px) {
	.style {
		padding-top: 50px;
		padding-bottom: 60px;
	}
	.style .inner-section {
		padding: 0 22px;
	}
	.style .project-subtit {
		margin-bottom: 22px;
	}
	.style .color-tit,
	.style .point-tit {
		margin-bottom: 17px;
	}
	.style .point-color-wrap .item {
		padding-left: 80px;
	}
	.style .point-color-wrap .color-section + .color-section {
		margin-top: 45px;
	}
	.style .point-color {
		display: flex;
	}
	.style .point-color .item {
		width: 33%;
	}
	.style .point-font-wrap {
		display: flex;
		flex-wrap: wrap;
		margin-top: 60px;
	}
	.style .point-font-wrap .project-subtit {
		width: 100%;
	}
	.style .point-font-wrap .font-section + .font-section {
		margin-left: 100px;
	}
}
@media screen and (min-width: 1280px) {
	.style {
		padding-top: 100px;
		padding-bottom: 140px;
	}
	.style .project-subtit {
		margin-bottom: 48px;
	}
	.style .color-tit,
	.style .point-tit {
		margin-bottom: 35px;
		font-size: 2.8rem;
	}
	.style .point-color-wrap .color {
		width: 120px;
		height: 120px;
	}
	.style .point-color-wrap .item {
		height: auto;
		min-height: 120px;
		padding-top: 33px;
		padding-left: 162px;
	}
	.style .point-color-wrap .tit {
		font-size: 2.2rem;
	}
	.style .point-color-wrap .code {
		font-size: 1.6rem;
	}
	.style .point-font-wrap {
		margin-top: 90px;
	}
	.style .point-font-wrap .font-tit {
		margin-bottom: 35px;
		font-size: 2.8rem;
	}
	.style .point-font-wrap .font-section .item img {
		width: 260px;
		border-radius: 30px;
	}
	.style .point-font-wrap .font-section + .font-section {
		margin-left: 200px;
	}
}
/* style [e] */
</style>


// WEBPACK FOOTER //
// src/projects/kb-card.vue